import { CSSObject } from '@chakra-ui/react';

export const TabsContentContainer: CSSObject = {
  px: '2',
  py: '0',
};
